import Typography from "@mui/material/Typography";
import nexgenjuniours from '../../../images/nexgenjuniorsicon.png';
import coding from '../../../images/codingicon.png';
import robotics from '../../../images/roboticsicon.png';
import AI_icon from '../../../images/AI_icon.png';

import { useTheme, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";

const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: "easeOut"
        }
    }
};

export default function Products() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    // Responsive image and text sizes
    const imageSize = isMobile ? 110 : 220;
    const titleFontSize = isMobile ? '40px' : '128px';
    const subtitleFontSize = isMobile ? '18px' : '32px';
    const labelFontSize = isMobile ? '18px' : '32px';

    return (
        <div style={{ marginBottom: '48px', backgroundColor: '#fff', textAlign: 'center', padding: '0 16px' }}>
            {/* Heading */}
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
            >
                <Typography
                    sx={{
                        fontSize: titleFontSize,
                        fontFamily: 'Montserrat',
                        fontWeight: 600,
                        color: '#3165F6',
                        lineHeight: 1.1
                    }}
                >
                    Products
                </Typography>
                <Typography
                    sx={{
                        fontSize: subtitleFontSize,
                        fontFamily: 'Montserrat',
                        fontWeight: 400,
                        color: '#111827'
                    }}
                >
                    that bring STEM to life
                </Typography>
            </motion.div>

            {/* Product Icons */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    gap: isMobile ? '32px' : '48px',
                    marginTop: '48px'
                }}
            >
                {/* Item 1 */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeInUp}
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                    <img src={nexgenjuniours} alt="Next Gen Juniors" style={{ width: imageSize, height: imageSize, marginBottom: 16 }} />
                    <Typography sx={{
                        fontSize: labelFontSize,
                        fontFamily: 'Montserrat',
                        fontWeight: 500,
                        color: '#111827'
                    }}>
                        Next Gen Juniors
                    </Typography>
                </motion.div>

                {/* Item 2 */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeInUp}
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                    <img src={coding} alt="Coding" style={{ width: imageSize, height: imageSize, marginBottom: 16 }} />
                    <Typography sx={{
                        fontSize: labelFontSize,
                        fontFamily: 'Montserrat',
                        fontWeight: 500,
                        color: '#111827'
                    }}>
                        Coding
                    </Typography>
                </motion.div>

                {/* Item 3 */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeInUp}
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                    <img src={robotics} alt="Robotics" style={{ width: imageSize, height: imageSize, marginBottom: 16 }} />
                    <Typography sx={{
                        fontSize: labelFontSize,
                        fontFamily: 'Montserrat',
                        fontWeight: 500,
                        color: '#111827'
                    }}>
                        Robotics
                    </Typography>
                </motion.div>

                {/* Item 4 */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeInUp}
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                    <img src={AI_icon} alt="Artificial Intelligence" style={{ width: imageSize, height: imageSize, marginBottom: 16 }} />
                    <Typography sx={{
                        fontSize: labelFontSize,
                        fontFamily: 'Montserrat',
                        fontWeight: 500,
                        color: '#111827'
                    }}>
                        Artificial Intelligence
                    </Typography>
                </motion.div>
            </div>
        </div>
    );
}
